import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const modules = {}
const requireStore = require.context('.', false, /\w+\.(store.js)$/)

requireStore.keys().forEach(fileName => {
  if (fileName !== './index.js') {
    const module_name = fileName
      .split('/')
      .pop()
      .replace(/\.\w+/g, '')
    // .replace(/\.\w+$/, '')

    modules[module_name] =
      requireStore(fileName).default || requireStore(fileName)
  }
})

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules
})
